import { gql } from "@outschool/ui-apollo";

//  $categorySlug: String!
//   where: { categorySlug: $categorySlug }
export const ContentfulEmailCaptureQuery = gql`
  query getContentfulEmailCapture(
    $categorySlug: String!
    $locale: String
    $preview: Boolean
  ) {
    contentfulClpEmailCaptureCollection(
      limit: 1
      skip: 0
      preview: $preview
      locale: $locale
      where: { clpPages: { value_contains: $categorySlug } }
    ) {
      items {
        name
        title
        bodyContent {
          json
        }
        callToActionText
        successMessage
        errorMessage
        prodIterableAudienceId
        stagingIterableAudienceId
        clpPagesCollection {
          items {
            value
          }
        }
      }
    }
  }
`;
